import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    projId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projMonitor.getAnalysis, {
        projId,
    }, options);
    if (error) return { error, status };
    return content || {
        monitorIds: [],
        monitorCount: 0,
        projId: '',
        year: 0,
        fMonth: 0,
        lMonth: 0,
        execQty: '',
        execRate: '',
        achieving: '',
        analysis: '',
        suggest: '',
    };
};

